import {useMutation} from '@apollo/client';
import {UPDATE_MANY_ORDER} from "../orderTypeDefs";

export const useMutationUpdateManyOrder = (options?: any): any => (
  useMutation(UPDATE_MANY_ORDER, options)
);
